import styled from 'styled-components';

export const ContactWrapper = styled.ul`
  list-style: disc;
  margin-left: 24px;
`;
